<div class="d-flex claim-sidebar">

  <div class="claim-procedure">
    <div class="claim-procedure-title">Frequently asked questions</div>
    <div class="claim-procedure-desc">Get instant answers to your most common <a class="faq-questions" [routerLink]="['/faq']"> questions</a>.</div>

  </div>
</div>